import styled from "styled-components";
import { Order_detail } from "../Interface/Order";
import { fontStyles } from "./common_font";
import { CenterView, RowView2 } from "./common_style";

interface TableStyle {
  $width?: number | null;
  $height?: number | null;
}

export const TableHeader = styled(RowView2)<TableStyle>`
  min-width: ${(props) => (props.$width ? `${props.$width}rem` : "140rem")};
  height: 2.5rem;
  border-top: 1px solid #8e8e8e;
  ${fontStyles.Bold}
  background-color: #e5e5e5;
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 100%;
    border: 1px solid #8e8e8e;
  }
`;
export const Table = styled(RowView2)<TableStyle>`
  min-width: ${(props) => (props.$width ? `${props.$width}rem` : "140rem")};
  height: ${(props) =>
    props.$height ? `${props.$height * 2.5}rem` : "2.5rem"};
  &.x2 {
    background-color: #f8f8f8;
  }
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 100%;
    border-bottom: 1px solid #8e8e8e;
    border-left: 1px solid #8e8e8e;
    overflow: hidden;
  }
  img {
    margin-left: 3px;
    cursor: pointer;
  }
`;
export const HeaderRow = styled(CenterView)<TableStyle>`
  flex: 1;
  max-width: ${(props) => (props.$width ? `${props.$width}rem` : "auto")};
  height: 100%;
  word-break: keep-all;
  text-align: center;
  border-bottom: 1px solid #8e8e8e;
  border-right: 1px solid #8e8e8e;
  overflow: hidden;
  &.flex3 {
    flex: 2;
  }
`;
export const Row = styled(CenterView)<TableStyle>`
  height: 100%;
  flex: 1;
  max-width: ${(props) => (props.$width ? `${props.$width}rem` : "auto")};
  word-break: keep-all;
  text-align: center;
  border-bottom: 1px solid #8e8e8e;
  border-left: 1px solid #8e8e8e;
  overflow: hidden;
  &.flex3 {
    flex: 2;
  }
  &.last {
    border-right: 1px solid #8e8e8e;
    flex: 2;
  }
`;
export const MultiRows = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #8e8e8e;
  }
`;

const keyMap: Record<
  | "seq"
  | "seq_check"
  | "주문일시"
  | "주문상태"
  | "상품번호"
  | "품목명"
  | "옵션"
  | "단가"
  | "수량"
  | "총 금액"
  | "상태변경일"
  | "운송장번호"
  | "환불메모",
  (data: Order_detail) => string | number | null
> = {
  seq: (data) => data.detail_seq,
  seq_check: (data) => data.detail_seq,
  주문일시: (data) => data.detail_order_dt.slice(0, 16).replaceAll("-", "."),
  상품번호: (data) => data.product_seq,
  품목명: (data) => data.product_name,
  옵션: (data) => data.option_name?.replace("&", "/") || "-",
  단가: (data) => data.product_price.toLocaleString("ko-KR"),
  수량: (data) => data.order_cnt,
  "총 금액": (data) => data.order_price.toLocaleString("ko-KR"),
  상태변경일: (data) =>
    data.status_update_dt?.slice(0, 16).replaceAll("-", ".") || "-",
  주문상태: (data) => data.order_status,
  운송장번호: (data) => data.delivery_info,
  환불메모: (data) => data.refund_memo,
};

const RenderMultiRows2 = ({
  detailData,
  searchkey,
  Component,
}: {
  detailData: Order_detail[];
  searchkey: string;
  Component?: React.ComponentType<{ detail_seq: number }>;
}) => {
  const height = detailData.length;

  return (
    <MultiRows>
      {detailData.map((item, idx) => {
        const nonborder = height === idx + 1 ? { border: 0 } : {};
        const text =
          searchkey in keyMap
            ? keyMap[searchkey as keyof typeof keyMap](item)
            : "";

        return (
          <div key={idx} style={nonborder}>
            {searchkey !== "seq_check" && text}
            {Component && <Component detail_seq={item.detail_seq} />}
          </div>
        );
      })}
    </MultiRows>
  );
};
export default RenderMultiRows2;
